// Location is a navigation hint only. Conversation reads still require the
// authenticated API's ownership checks; no messages or credentials are cached.
export function readConversationLocation(): string | null {
  const id = new URLSearchParams(window.location.search).get('conversation');
  return id && /^[A-Za-z0-9_-]{1,128}$/.test(id) ? id : null;
}

export function rememberConversationLocation(id: string | null) {
  const url = new URL(window.location.href);
  if (id) url.searchParams.set('conversation', id);
  else url.searchParams.delete('conversation');
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
}

export function reloadWorkspace() {
  window.location.reload();
}
